import { Component, OnInit, Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SpinnerService } from './spinner.service';
const SPINNER_MESSAGE = '';

@Component({
  selector: 'app-spinner-component',
  templateUrl: './spinner-component.component.html',
  styleUrls: ['./spinner-component.component.scss'],
  standalone: false
})
export class SpinnerComponentComponent implements OnInit {
  @Input() show: boolean;
  LOADING_TEXT: string;

  constructor(private spinner: NgxSpinnerService,
    private spinnerService: SpinnerService) { }

  ngOnInit() {
    this.LOADING_TEXT = SPINNER_MESSAGE;
    this.spinnerService.getData().subscribe(data => {
      if (data) {
        this.spinner.show();
      } else {
        this.spinner.hide();
      }
    });
  }

}
